import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class FormatService {

    constructor() {}

    public mapSurveyData(data: any): Observable<any> {

        let currentDt = new Date();
        let openDt = this.formatDate(data.surveyOpenDate);
        let closeDt = this.formatDate(data.surveyCloseDate);

        let survey: any = {
            closeDt: closeDt,
            openDt: openDt,
            projectId: data.projectId,
            projectName: data.projectName,
            surveyCode: data.groupLevel,
            surveyId: data.surveyId,
            surveyName: data.surveyName,
            isVisible: data.isVisible,
            open: currentDt < closeDt && currentDt > openDt ? true : false,
            groupLevelId: data.groupLevelId
        }

        return survey;
    }

    formatDate(date: string) {
        let splitDate: any = date.substring(0,10).split('-');
        let newDate = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);
        return newDate;
    }

}